module.exports = __webpack_public_path__ + "static/img/rank-3.a30dcf4c.svg";